<template>
    <div class="vx-col md:w-full sm:w-auto">
        <div class="vx-row md:w-full">
            <vx-tooltip class="position-icon" :text="$t('equipment.allocation')" position="top" v-if="isPermissionAssign()">
                <feather-icon icon="UserIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
                              @click="assignDevice"/>
            </vx-tooltip>

            <vx-tooltip class="position-icon" :text="$t('button.edit')" position="top" v-if="isPermissionUpdate()">
                <feather-icon icon="EditIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
                              @click="editRecord"/>
            </vx-tooltip>

            <vx-tooltip class="position-icon" :text="$t('button.delete')" position="top" v-if="isPermissionDelete()">
                <feather-icon icon="TrashIcon" class="action-err icon-btn"
                              svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                              @click="confirmDeleteRecord"/>
            </vx-tooltip>
        </div>
    </div>
</template>

<script>

import { isAPI, isRouter } from '../../../../store/permission';
import { constAPI, constRouter } from '../../../../store/constant';

export default {
    name: 'CellRendererActions',
    methods: {
        isPermissionUpdate() {
            return isRouter(this, constRouter.equipment_update)
        },
        isPermissionDelete() {
            return isAPI(this, constAPI.equipment_delete)
        },
        isPermissionAssign() {
            return isRouter(this, constRouter.equipment_assign)
        },
        assignDevice() {
            this.$router.push(`/user/assign-equipment?branch_id=${this.params.data.organizationBranchId}&device_id=${this.params.data.id}`).catch(() => {
            })
        },
        editRecord() {
            this.$router.push(`/user/edit-equipment?branch_id=${this.params.data.organizationBranchId}&id=${this.params.data.id}`).catch(() => {
            })
        },
        confirmDeleteRecord() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xoá`,
                text: `Bạn có chắc là muốn xoá vận dụng "${this.params.data.type}" không ?`,
                accept: this.deleteRecord,
                acceptText: "Xoá",
                cancelText: "Huỷ"
            })
        },
        deleteRecord() {
            this.$vs.loading();
            this.$crm.post('/device/delete/' + this.params.data.id).then(() => {
                this.$vs.loading.close();
                this.showDeleteSuccess();
                this.$store.commit('UPDATE_DEVICE', true);
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        showDeleteSuccess() {
            this.$vs.notify({
                color: 'success',
                text: 'Xoá thành công',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
            })
        },
        confirmRevoke() {
            if (!this.params.data.employeeId) {
                return this.$vs.dialog({
                    color: 'danger',
                    title: `Lỗi`,
                    text: `Không thể thu hồi thiết bị chưa cấp phát`,
                    acceptText: "Đồng ý"
                })
            }
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận thu hồi`,
                text: `Bạn có chắc là muốn thu hồi không ?`,
                accept: this.revokeDevice,
                acceptText: "Xác nhận",
                cancelText: "Huỷ"
            })
        },
        revokeDevice() {
            this.$vs.loading();
            this.$crm.post('/device/revoke/' + this.params.data.id).then(() => {
                this.$vs.loading.close();
                this.showRevokeSuccess();
                this.$store.commit('UPDATE_DEVICE', true);
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        showRevokeSuccess() {
            this.$vs.notify({
                color: 'success',
                text: 'Thu hồi thành công',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
            })
        }
    }
}
</script>
<style scoped>

</style>
